document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonial').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testimonial-slide]'));
    if (slides.length < 2) return;

    var current = slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    });
    if (current < 0) current = 0;

    function show(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    var prevBtn = root.querySelector('[data-testimonial-prev]');
    var nextBtn = root.querySelector('[data-testimonial-next]');

    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
  });
});
